export default "__VITE_ASSET__CRvTMZP3__"